import React, { createContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import categoryData from '../assets/categories.json';
// Create the context
export const CoursesContext = createContext();

// Create the provider component
export function CoursesProvider({ children }) {    const [categories, setCategories] = useState([]);
    const [coursesMap, setCoursesMap] = useState(new Map()); // Map to store courses by category
    const [currentCourses, setCurrentCourses] = useState([]); // Courses for the currently selected category
    const [categoryDetails, setCategoryDetails] = useState(categoryData);
    const [allCourses, setAllCourses] = useState([]); // All courses fetched from the flat file
    const [dataLoaded, setDataLoaded] = useState(false); // Indicator that data has been loaded


    useEffect(() => {
        // Always use the local public folder version
        // This works for both development, production, and react-snap pre-rendering
        let globalJsonUrl = "/courses/all_courses.json";
        fetch(globalJsonUrl)
            .then((response) => response.json())
            .then((data) => {           
                setAllCourses(data.courses); // pull the courses out from the JSON structure
                console.log("managed to get all courses from the cloudfront dist", data.courses.length);
                 // Extract all unique categories from all courses
            const uniqueCategories = new Set();
            data.courses.forEach(course => {
                if (Array.isArray(course.categories)) {
                    course.categories.forEach(category => uniqueCategories.add(category));
                }
            });
            setCategories(Array.from(uniqueCategories));
            
            // I want to set the coursesMap property to have each of the categories as a key and then the courses that belong to that category as an array
            const newCoursesMap = new Map();
            data.courses.forEach(course => {
                if (Array.isArray(course.categories)) {
                    course.categories.forEach(category => {
                        if (!newCoursesMap.has(category)) {
                            newCoursesMap.set(category, []);
                        }
                        newCoursesMap.get(category).push(course);
                    });
                }
            });            setCoursesMap(newCoursesMap);
            setDataLoaded(true); // Set data loaded flag to true
        })
        .catch((error) => {
                console.error('Error fetching all courses from cloudfront dist:', error);
                setDataLoaded(true); // Set to true even on error to prevent endless loading state
            });
    }, []);


       return (
        <CoursesContext.Provider value={{ categories, coursesMap, currentCourses, categoryDetails, allCourses, dataLoaded }}>
            {children}
        </CoursesContext.Provider>
    );
}